import { Asset } from '../services/product/product-data'
import { isFeatureEnabled } from './feature-toggle/feature-toggle'
import { FEATURE_TOGGLES } from './feature-toggle/constants'
import { PageConfig } from './page-config'

/**
 * Resolves the image URL for an asset based on feature toggle state,
 * author mode, and asset type.
 *
 * Returns assetRelativePath (same-domain) when:
 * - ASSET_RELATIVE_PATH toggle is enabled
 * - Asset type is 'Image'
 * - Not on AEM author instance
 * - assetRelativePath is non-empty
 *
 * Otherwise falls back to assetFullUrl.
 */
export const getAssetImageUrl = (asset?: Asset): string | undefined => {
  if (
    isFeatureEnabled(FEATURE_TOGGLES.ASSET_RELATIVE_PATH) &&
    asset?.assetType === 'Image' &&
    !PageConfig.config?.isAuthor &&
    asset?.assetRelativePath
  ) {
    return asset.assetRelativePath
  }

  return asset?.assetFullUrl
}
